import React, { Component } from 'react';
import { Flex } from 'core/components';
import { observer } from 'mobx-react';
import MetricsExplorerResult from 'app/views/metrics/MetricsExplorerResult';
import MetricsExplorerButton from 'app/views/metrics/MetricsExplorerButton';
import styled from 'styled-components';
import ToolResultCard from '../components/ToolResultCard';

const NmsWrapper = styled(Flex)`
  .me-tools {
    padding: 0 16px;
    margin: 0;
  }
`;

@observer
class NmsToolResult extends Component {
  render() {
    const { tool, chartHeight, onCloseToolResult, isInlineMode } = this.props;

    if (!tool || !tool.query_object) {
      return <Flex>Invalid tool data for NMS.</Flex>;
    }

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-nms"
        title={tool.title}
        minHeight={chartHeight}
        headerActions={
          <MetricsExplorerButton openInNewWindow text="View in Metrics Explorer" query={tool.query_object} />
        }
      >
        <NmsWrapper flexDirection="column" flex={1} overflow="hidden" position="relative">
          <MetricsExplorerResult
            query={tool.query_object}
            showLegend
            showTools
            isWidget
            hideTotalRow
            chartHeight={chartHeight}
          />
        </NmsWrapper>
      </ToolResultCard>
    );
  }
}

export default NmsToolResult;
